import { render, staticRenderFns } from "./DragableModal.vue?vue&type=template&id=551ce168&"
import script from "./DragableModal.vue?vue&type=script&lang=js&"
export * from "./DragableModal.vue?vue&type=script&lang=js&"
import style0 from "./DragableModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports